import { FC, useMemo } from 'external/react'

const footerStyles: (canSave: boolean) => any = canSave => ({
  root: {
    padding: '14px 24px 20px',
    display: 'flex', gap: 10, justifyContent: 'flex-end',
    borderTop: '1px solid #f1f5f9',
  },
  save: {
    padding: '9px 22px', borderRadius: 8,
    border: 'none', color: '#fff',
    fontSize: 14, fontWeight: 700,
    transition: 'background 150ms',
    background: canSave ? '#0ea5e9' : '#cbd5e1',
    cursor: canSave ? 'pointer' : 'not-allowed',
    boxShadow: canSave ? '0 2px 8px rgba(14,165,233,0.35)' : 'none',
  }
});


type ChangeCourseModalProps = {
  canSave: boolean
  handleSave: () => void;
};

const ChangeCourseModalFooter: FC<ChangeCourseModalProps> = ({ canSave, handleSave }) => {
  const styles = useMemo(() => footerStyles(canSave), [canSave])
  return (
    <div style={styles.root}>
      <button
        disabled={!canSave}
        onClick={handleSave}
        style={styles.save}
        onMouseEnter={e => { if (canSave) e.currentTarget.style.background = '#0284c7'; }}
        onMouseLeave={e => { if (canSave) e.currentTarget.style.background = '#0ea5e9'; }}
      >
        Guardar cambio
      </button>
    </div>
 );
};

export default ChangeCourseModalFooter